import React from 'react';
import { useParams } from 'react-router-dom';
import { StoreReportApi } from '../../api/storeReportApi';
import { Reports } from '../../shared-components';

const SalesByProductContainer = () => {
  const { storeId } = useParams();

  const fetchStoreReport = (startDate, endDate) => {
    return StoreReportApi.getSalesByProduct(storeId, startDate, endDate).then((res) => res.data);
  };

  const fetchProductBuyers = (variantId, startDate, endDate) => {
    return StoreReportApi.getProductBuyers(storeId, variantId, startDate, endDate).then((res) => res.data);
  };

  return (
    <Reports.SalesByProduct storeId={storeId} fetchStoreReport={fetchStoreReport} fetchProductBuyers={fetchProductBuyers} />
  );
};

export default SalesByProductContainer;